import { actions } from "common/store/collection";

export const NAMESPACE = "DEVICE/TAGS_HISTORY";

const tagsHistoryActions = actions.factory(NAMESPACE);

export const { LOAD, LOAD_SUCCESS, LOAD_ERROR, CLEAR } = tagsHistoryActions.TYPES;

export const { loadSuccess, loadError, clear } = tagsHistoryActions;

export const LOAD_NOTHING = 'DEVICE/TAGS_HISTORY/LOAD_NOTHING';
export const DETACH_SUCCESS_FROM_TAGS_HISTORY = 'DEVICE/DETACH_SUCCESS_FROM_TAGS_HISTORY';

export const load = (deviceId, pageNum, tagsData, limit) => ({
  ...tagsHistoryActions.load(),
  deviceId,
  pageNum,
  tagsData,
  limit,
});

export const detachSuccessFromTagsHistory = (uniqueId) => ({
  type: DETACH_SUCCESS_FROM_TAGS_HISTORY,
  uniqueId
});

export const loadNothing = () => ({
  type: LOAD_NOTHING
});
